import {
  Button,
  Checkbox,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Portal,
  Tag,
} from '@chakra-ui/react';
import { EntityTag } from '@texas/api/endpoints/tagsApi';
import { useTranslation } from 'react-i18next';
import { Icons } from '../shared/Icons';

interface SupplierTagFilterProps {
  tags: EntityTag[];
  selectedTagIds?: number[];
  onChange: (tagIds?: number[]) => void;
  isLoading?: boolean;
}

export function SupplierTagFilter({
  tags,
  selectedTagIds = [],
  onChange,
  isLoading = false,
}: SupplierTagFilterProps) {
  const { t } = useTranslation();
  const selectedCount = selectedTagIds.length;

  const toggleTag = (tagId: number) => {
    const tagIds = selectedTagIds.includes(tagId)
      ? selectedTagIds.filter((id) => id !== tagId)
      : [...selectedTagIds, tagId];

    onChange(tagIds.length > 0 ? tagIds : undefined);
  };

  return (
    <Menu closeOnSelect={false} isLazy={true}>
      <MenuButton
        as={Button}
        h="38px"
        isDisabled={isLoading || tags.length === 0}
        minW="150px"
        rightIcon={<Icons.ChevronDown boxSize={4} />}
        size="sm"
        variant={
          selectedCount > 0
            ? 'entityDirectoryFilterActive'
            : 'entityDirectoryFilter'
        }
      >
        {t('general.tags')}: {selectedCount || t('filter.all')}
      </MenuButton>
      <Portal>
        <MenuList maxH="320px" minW="240px" overflowY="auto" zIndex={20}>
          <MenuItem
            fontWeight={selectedCount === 0 ? 'semibold' : 'normal'}
            onClick={() => onChange(undefined)}
          >
            {t('tags.filter.all')}
          </MenuItem>
          <MenuDivider />
          {tags.map((tag) => (
            <MenuItem key={tag.id} onClick={() => toggleTag(tag.id)}>
              <Checkbox
                isChecked={selectedTagIds.includes(tag.id)}
                mr={2}
                pointerEvents="none"
              />
              <Tag bg={tag.color} color="white" fontWeight="bold" size="sm">
                {tag.label}
              </Tag>
            </MenuItem>
          ))}
        </MenuList>
      </Portal>
    </Menu>
  );
}
